import { render, staticRenderFns } from "./template.html?vue&type=template&id=bfe869d4&"
import script from "./script.ts?vue&type=script&lang=js&"
export * from "./script.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports